import React from 'react';
import NavBar from '../components/Navbar/NavBar';
import Footer from '../components/Footer';

const Games = () => {
    return (
        <>
            <div>
                <NavBar />
            </div>
            
            <div className="bg-gray-100 min-h-screen pt-20">
                <div className="container mx-auto px-4 py-12">
                    <h1 className="text-4xl font-bold text-blue-900 text-center mb-12">Our Games</h1>
                    
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                        {/* Game Card 1 */}
                        <div className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
                            <div className="h-48 bg-blue-900">
                                {/* Game image will go here */}
                            </div>
                            <div className="p-6">
                                <h2 className="text-2xl font-bold text-blue-900 mb-3">Game 1</h2>
                                <p className="text-gray-600 mb-4">Experience an exciting adventure in this immersive game world...</p>
                                <button className="bg-blue-900 text-white px-6 py-2 rounded-lg hover:bg-blue-800 transition-colors">
                                    Play Now
                                </button>
                            </div>
                        </div>

                        {/* Game Card 2 */}
                        <div className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
                            <div className="h-48 bg-blue-900">
                                {/* Game image will go here */}
                            </div>
                            <div className="p-6">
                                <h2 className="text-2xl font-bold text-blue-900 mb-3">Game 2</h2>
                                <p className="text-gray-600 mb-4">Test your skills in this challenging puzzle game...</p>
                                <button className="bg-blue-900 text-white px-6 py-2 rounded-lg hover:bg-blue-800 transition-colors">
                                    Play Now
                                </button>
                            </div>
                        </div>

                        {/* Game Card 3 */}
                        <div className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
                            <div className="h-48 bg-blue-900">
                                {/* Game image will go here */}
                            </div>
                            <div className="p-6">
                                <h2 className="text-2xl font-bold text-blue-900 mb-3">Game 3</h2>
                                <p className="text-gray-600 mb-4">Join multiplayer battles in this action-packed game...</p>
                                <button className="bg-blue-900 text-white px-6 py-2 rounded-lg hover:bg-blue-800 transition-colors">
                                    Play Now
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </>
    );
};

export default Games; 